import { useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Button } from '@orbita-ui/core';
import { useNavigate } from 'react-router-dom';

import { PageTitle } from 'shared/components/Fonts';
import { Card } from 'shared/components';
import { FUNCIONALIDADES, FUNCIONALIDADES_LABEL } from 'user/constants/Funcionalidad';
import { EDIT_USERS_PATH } from 'user/routes';
import { UserInfoContext } from 'user/context/UserInfoContext';
import { UserDetailPageSkeleton } from './UserDetailPageSkeleton';
import { Tarjeta } from 'core/tarjeta/models/Tarjeta';
import { FormLabel, FormLabelTitle } from 'user/share/components/FormLabel';
import { mapTipoUsuario } from 'user/models/Usuario';
import { CentroCosto } from 'core/centrocosto/models/CentroCosto';

export function UserDetailPage() {
  const { userInfo, isLoading } = useContext(UserInfoContext);
  const navigate = useNavigate();

  return (
    <Container fluid>
      {isLoading ? (
        <UserDetailPageSkeleton />
      ) : (
        <>
          <Row className="mb-3">
            <Col>
              <PageTitle>Información del Usuario</PageTitle>
            </Col>
            <Col>
              {!userInfo?.cuentaRaiz && (
                <Button
                  className="float-end"
                  type="button"
                  onClick={() =>
                    navigate(EDIT_USERS_PATH.replace(':userId', `${userInfo.id}`), {
                      state: { userId: userInfo.id },
                    })
                  }
                >
                  Editar
                </Button>
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              <Card>
                <Card.Title>Datos del usuario</Card.Title>
                <Card.Body $padding>
                  <Row className="mb-2">
                    <Col>
                      <FormLabelTitle>Código de usuario</FormLabelTitle>
                      <FormLabel>{userInfo?.username}</FormLabel>
                    </Col>
                    <Col>
                      <FormLabelTitle>Email</FormLabelTitle>
                      <FormLabel>{userInfo?.mail}</FormLabel>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <FormLabelTitle>Nombre y Apellido</FormLabelTitle>
                      <FormLabel>{userInfo?.detalle}</FormLabel>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              <br />
              <Card>
                <Card.Title>Información que puede consultar</Card.Title>
                <Card.Body $padding>
                  <Row className="mb-2">
                    <Col>
                      <FormLabelTitle>Tipo de Usuario</FormLabelTitle>
                      <FormLabel>{mapTipoUsuario(userInfo?.tipoUsuario)}</FormLabel>
                    </Col>
                    <Col>
                      <FormLabelTitle>Cuenta</FormLabelTitle>
                      <FormLabel>{userInfo?.recursoControlado.numeroCuenta}</FormLabel>
                    </Col>
                  </Row>
                  {/* Condicional */}
                  {userInfo?.tipoUsuario === 'CENTRO_COSTO' && (
                    <Row>
                      <Col md="12">
                        <FormLabelTitle>Nombre del centro de costos</FormLabelTitle>
                        <FormLabel>
                          {(userInfo?.recursoControlado as CentroCosto).nombre || '-'}
                        </FormLabel>
                      </Col>
                    </Row>
                  )}
                  {userInfo?.tipoUsuario === 'TARJETA' && (
                    <Row>
                      <Col md="12">
                        <FormLabelTitle>Nro de Tarjeta</FormLabelTitle>
                        <FormLabel>
                          {(userInfo?.recursoControlado as Tarjeta).numero || '-'}
                        </FormLabel>
                      </Col>
                    </Row>
                  )}
                </Card.Body>
              </Card>

              <br />
              <Card>
                <Card.Title>Funcionalidades</Card.Title>
                <Card.Body $padding>
                  <Row>
                    <Col>
                      {userInfo?.funcionalidades?.map((item, index) => (
                        <Row key={`${item}-${index}`} className="mb-4">
                          <Col>
                            <FormLabelTitle>{FUNCIONALIDADES_LABEL[item]}</FormLabelTitle>
                            <FormLabel>{FUNCIONALIDADES[item]}</FormLabel>
                          </Col>
                        </Row>
                      ))}
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
}
